const SITE_CONTENT_API_URL = '/api/site-content';
const PUBLIC_SITE_CONTENT_URL = '/site-content.json';

const extractErrorMessage = async (response, fallbackMessage) => {
  const payload = await response.json().catch(() => ({}));
  return payload?.message || fallbackMessage;
};

export const fetchRemoteSiteContent = async () => {
  const response = await fetch(SITE_CONTENT_API_URL, {
    method: 'GET',
    headers: { accept: 'application/json' },
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Site content alinamadi.'));
  }

  const data = await response.json().catch(() => ({}));
  return {
    content: data?.content && typeof data.content === 'object' ? data.content : null,
    updatedAt: typeof data?.updatedAt === 'string' ? data.updatedAt : null,
    storageMode: data?.storageMode === 'blob' ? 'blob' : 'memory',
  };
};

export const pushRemoteSiteContent = async (content) => {
  const response = await fetch(SITE_CONTENT_API_URL, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ content }),
  });

  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Site content kaydedilemedi.'));
  }

  return response.json().catch(() => ({}));
};

export const fetchPublicSiteContent = async () => {
  const cacheBustedUrl = `${PUBLIC_SITE_CONTENT_URL}?t=${Date.now()}`;
  const response = await fetch(cacheBustedUrl, {
    method: 'GET',
    headers: { accept: 'application/json' },
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Public site content alinamadi.'));
  }

  const data = await response.json().catch(() => null);
  return data && typeof data === 'object' ? data : null;
};
